import React from "react";
import Grid from "@mui/material/Grid";

//Formik
import { Formik, Form, Field, FormikProps } from "formik";
import { TextField } from "formik-material-ui";
import Button, { ButtonProps } from "@mui/material/Button";
import ClientCaptcha from "react-client-captcha";
import axios from "axios";
import Swal from "sweetalert2";

function ContactForm() {
  const [captcha, setCaptcha] = React.useState("");
  const [file, setFile] = React.useState();
  const [button, setButton] = React.useState(false);

  return (
    <div>
      <Formik
        initialValues={{
          fullname: "",
          companyname: "",
          department: "",
          tel: "",
          fax: "",
          email: "",
          subject: "",
          detail: "",
          recaptcha: "",
        }}
        onSubmit={async (values) => {
          const fullname = values.fullname;
          const companyname = values.companyname;
          const department = values.department;
          const tel = values.tel;
          const fax = values.fax;
          const email = values.email;
          const subject = values.subject;
          const detail = values.detail;
          const recaptcha = values.recaptcha;
          if (captcha === recaptcha) {
            var formData = new FormData();
            formData.append("fullname", fullname);
            formData.append("company_name", companyname);
            formData.append("department", department);
            formData.append("phone_number", tel);
            formData.append("fax", fax);
            formData.append("email", email);
            formData.append("subject", subject);
            formData.append("detail", detail);
            formData.append("language", "TH");
            setButton(true);

            if (file) {
              var filename = file.name;
              formData.append("file", file, filename);
              const url = process.env.NEXT_PUBLIC_BASE_URL_API;
              const response = await axios.post(
                `${url}/v1/contact/withimage`,
                formData
              );
              if (response.data.status == "success") {
                Swal.fire(
                  "Success!",
                  "ขอบคุณที่ให้ความสนใจในผลิตภัณฑ์และบริการของเรา <br/> เราจะติดต่อกลับโดยเร็วที่สุด",
                  "success"
                ).then(function () {
                  location.reload();
                });
              } else {
                Swal.fire("Error!", "Please check your input.", "error").then(
                  function () {
                    return false;
                  }
                );
              }
            } else {
              const url = process.env.NEXT_PUBLIC_BASE_URL_API;
              const response = await axios.post(`${url}/v1/contact`, formData);
              if (response.data.status == "success") {
                Swal.fire(
                  "Success!",
                  "ขอบคุณที่ให้ความสนใจในผลิตภัณฑ์และบริการของเรา <br/> เราจะติดต่อกลับโดยเร็วที่สุด",
                  "success"
                ).then(function () {
                  location.reload();
                });
              } else {
                Swal.fire("Error!", "Please check your input.", "error").then(
                  function () {
                    return false;
                  }
                );
              }
            }
          } else {
            setButton(false);
            Swal.fire("Error!", "Please check your captcha.", "error").then(
              function () {
                return false;
              }
            );
          }
        }}
      >
        <Form>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">
                ชื่อ - นามสกุล <span className="text-danger">*</span>
              </label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="fullname"
                id="fullname"
                margin="normal"
                required
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">
                ชื่อบริษัท <span className="text-danger">*</span>
              </label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="companyname"
                id="companyname"
                margin="normal"
                required
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">แผนก</label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="department"
                id="department"
                margin="normal"
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">
                เบอร์โทรศัพท์ <span className="text-danger">*</span>
              </label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="tel"
                id="tel"
                margin="normal"
                required
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">เบอร์แฟกซ์</label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="fax"
                id="fax"
                margin="normal"
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">
                อีเมล์ <span className="text-danger">*</span>
              </label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="email"
                id="email"
                margin="normal"
                required
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
                type="email"
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">
                เรื่อง <span className="text-danger">*</span>
              </label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="subject"
                id="subject"
                margin="normal"
                required
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="start"
            sx={{ mt: 0.5 }}
          >
            <Grid item xs={12} md={3} sx={{ mb: 2 }} alignItems="start">
              <label className="fw-bold">
                รายละเอียด <span className="text-danger">*</span>
              </label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="detail"
                id="detail"
                margin="normal"
                required
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
                multiline
                rows={4}
              />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 0.5 }}
          >
            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">แนบไฟล์</label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <input
                className="form-control"
                type="file"
                id="formFile"
                name="file"
                onChange={(e) => {
                  setFile(e.target.files[0]);
                }}
              />
            </Grid>

            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold"></label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <ClientCaptcha captchaCode={(code) => setCaptcha(code)} />
            </Grid>

            <Grid item xs={12} md={3} sx={{ mb: 2 }}>
              <label className="fw-bold">
                รหัสยืนยัน <span className="text-danger">*</span>
              </label>
            </Grid>
            <Grid item xs={12} md={9} sx={{ mb: 2 }}>
              <Field
                component={TextField}
                name="recaptcha"
                id="recaptcha"
                margin="normal"
                required
                fullWidth
                autoComplete="off"
                size="small"
                hiddenLabel
                onKeyDown={(e) => {
                  if (e.code === "Enter" || e.code === "NumpadEnter") {
                    e.preventDefault();
                  }
                }}
              />
            </Grid>
          </Grid>

          <div className="col-12 text-center my-5 ms-auto btn-send">
            <Button
              type="submit"
              className=""
              variant="contained"
              color="primary"
              disabled={button}
            >
              ส่ง
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}
export default ContactForm;
